module.exports = "<p>\r\n  auto-logout works!\r\n</p>\r\n"